module.exports = __webpack_public_path__ + "img/alert_email_null_icon.c8f9cd53.png";